import { serviceEvent } from "../service/event";

/**
 * Plugin Nuxt untuk menyediakan registry service shared.
 *
 * Tujuannya agar pemanggil cukup memakai `useNuxtApp().$services`
 * tanpa perlu mengetahui implementasi endpoint per domain.
 */
export default defineNuxtPlugin(() => {
  const $services = {
    event: serviceEvent(),
  };

  return {
    provide: {
      services: $services,
    },
  };
});
